import { forwardRef } from 'react';
import { Link } from 'react-router';
import { t } from 'components/translation/Translation';
import UserAvatar from 'components/UserAvatar/UserAvatar';
// styles
import styles from './profile-menu.module.scss';
import { scholaMatchLink } from 'constants/url-links';

const ProfileMenu = forwardRef(({ routesProfileMenu, openSettings, openResetPassword, fullname }, ref) => {
  const profile = routesProfileMenu[0];
  const password = routesProfileMenu[1];
  const enrollment = routesProfileMenu.slice(2, 4);
  const links = routesProfileMenu.slice(4, 7);
  const resources = routesProfileMenu.slice(7, 9);
  const logOut = routesProfileMenu[routesProfileMenu.length - 1];

  return (
    <div className={styles.profile_menu} data-testid="profileMenu">
      <ul className={styles.profile_menu_container} ref={ref}>
        <div className={styles.profile_menu_user}>
          <UserAvatar user={fullname} />
          <p>{fullname}</p>
        </div>

        <li className={styles.item_separator}>{t('parent:layout.accountSettings')}</li>

        <li className={styles.item}>
          <Link to={profile.to} onClick={openSettings}>
            {profile.icon} <span>{profile.displayName}</span>
          </Link>
        </li>
        <li className={styles.item}>
          <Link to={password.to} onClick={openResetPassword}>
            {password.icon} <span>{password.displayName}</span>
          </Link>
        </li>
        <li className={styles.item_separator}>{t('parent:layout.enrollmentSteps')}</li>
        {enrollment.map((route, index) => (
          <li className={styles.item} key={index}>
            <Link
              to={route.to !== '/scholaMatch' && route.to}
              href={route.to === '/scholaMatch' && scholaMatchLink}
              target={route.to === '/scholaMatch' && '_blank'}>
              {route.icon} <span>{route.displayName}</span>
            </Link>
          </li>
        ))}
        <li className={styles.item_separator}>{t('parent:layout.quickLinks')}</li>
        {links.map((route, index) => (
          <li className={styles.item} key={index}>
            <Link to={route.to}>
              {route.icon} <span>{route.displayName}</span>
            </Link>
          </li>
        ))}
        <li className={styles.item_separator}>{t('parent:layout.resources')}</li>
        {resources.map((route, index) => (
          <li className={styles.item} key={index}>
            <Link to={route.to}>
              {route.icon} <span>{route.displayName}</span>
            </Link>
          </li>
        ))}

        <li className={styles.item_logout}>
          <Link to={logOut.to}>{logOut.displayName}</Link>
        </li>
      </ul>
    </div>
  );
});

export default ProfileMenu;
